import React from 'react'
import { Box } from '@chilipiper/design-system'
import { AvatarPlaceholder } from '../avatar-placeholder'
import { useFetchImage } from '../hooks'
import { AvatarProps } from '../types'
import { useImageResolver } from './hooks'

export const UserAvatar = React.memo((props: Omit<AvatarProps, 'image'>) => {
  const resolver = useImageResolver(props.id || '')
  const { image } = useFetchImage(resolver)

  return (
    <Box position='relative' display='inline'>
      <AvatarPlaceholder crossOrigin='anonymous' image={image} {...props} />
    </Box>
  )
})

UserAvatar.displayName = 'UserAvatar'
